import {KeyLabel} from './key-label.model';
export enum DevicePlacement {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  MW = 'MW',
}

export const DevicePlacementLabels = {
  DESKTOP: 'Desktop',
  MW: 'Mobile Web',
};

export const DevicePlacementKL = () => Object.keys(DevicePlacementLabels).map(key => new KeyLabel(key, DevicePlacementLabels[key]));
